module.exports = __webpack_public_path__ + "static/media/upload.d0a9635d.svg";